import { Link, useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLoad } from "@/lib/hooks";
import { fmt, fdate } from "@/lib/api";
import { MARGIN_LABEL, marginOnCost } from "./FinishingOps";
import { useAccess } from "@/context/AuthContext";
import { PageHeader, Section, StatusBadge, EmptyRow } from "@/components/common";
import { PageSearch } from "@/components/PageSearch";

export const QUOTE_BADGE = { draft: "draft", pending_approval: "pending", approved: "approved", issued: "issued", accepted: "accepted", rejected: "failed", expired: "expired", converted: "converted" };

export default function Quotes() {
  const [all] = useLoad("/quotes");
  const [params, setParams] = useSearchParams();
  const fst = params.get("status");
  const rows = all?.filter((q) => !fst || (q.status || "draft") === fst);
  const { canWrite, currency } = useAccess();
  return (
    <>
      <PageHeader title="Quotations" subtitle="Formula-driven estimates for offset, digital, large format and label/packaging.">
        <PageSearch testId="quotes-search" placeholder="Search quote number, customer or title" />
        {fst && <button data-testid="quotes-clear-filter" onClick={() => setParams({})} className="po-chip po-tone-info self-center !normal-case">Filtered: status {fst.replace("_", " ")} ×</button>}
        {canWrite(["tenant_admin", "accountant", "sales"]) && <Button asChild className="bg-[#45BFB4] text-[#13294B] hover:bg-[#389F95] hover:text-white"><Link to="/app/quotes/new" data-testid="new-quote-button"><Plus className="mr-1 h-4 w-4" />New quote</Link></Button>}
      </PageHeader>
      <Section>
        <div className="overflow-x-auto"><table className="po-table" data-testid="quotes-table">
          <thead><tr><th>Number</th><th>Customer</th><th>Title</th><th>Service lines</th><th>Version</th><th>Status</th><th>Valid until</th><th className="po-num">{MARGIN_LABEL}</th><th className="po-num">Total</th></tr></thead>
          <tbody>{rows?.length === 0 && <EmptyRow cols={9} />}{rows?.map((q) => { const st = q.status || "draft"; const tot = q.totals || {}; return (
            <tr key={q.id} data-testid={`quote-row-${q.number}`}>
              <td><Link className="font-medium text-[#13294B] hover:underline" to={`/app/quotes/${q.id}`}>{q.number || "—"}</Link></td><td>{q.customer_name || "—"}</td><td>{q.title || "—"}</td>
              <td className="capitalize text-xs">{(q.service_lines || []).map((s) => (s || "").replace("_", " ")).join(", ") || "—"}</td><td>v{q.current_version ?? 1}</td>
              <td><StatusBadge status={QUOTE_BADGE[st]} label={st.replace("_", " ")} /></td><td>{q.valid_until ? fdate(q.valid_until) : "—"}</td>
              <td className="po-num" data-testid={`quote-row-margin-${q.number}`}>{marginOnCost(tot.total, tot.cost)}%</td><td className="po-num font-medium">{fmt(tot.total || 0, currency)}</td>
            </tr>
          ); })}</tbody>
        </table></div>
      </Section>
    </>
  );
}
